document.addEventListener('DOMContentLoaded', () => {
    const COOKIE_NAME = 'vila_discount_offer';
    const COOKIE_LIFETIME_SECONDS = 5 * 60 * 60;
    const SHOP_ROOT = document.currentScript?.dataset.shopRoot || '/';
    const OFFER_DISCOUNT_CODES = new Set(['300-poklon', '600-poklon']);
    const DISCOUNT_STORAGE_KEYS = [
    'vilaDiscountActivated',
    'vilaDiscountCode',
    'vilaDiscountValue'
    ];

    const hasCookie = () => document.cookie
    .split(';')
    .some(cookie => cookie.trim().startsWith(COOKIE_NAME + '='));

    const removeStoredDiscount = () => {
    DISCOUNT_STORAGE_KEYS.forEach(key => {
        try {
        localStorage.removeItem(key);
        } catch (error) {
        // The cart discount is still cleared if storage is unavailable.
        }
    });
    };

    const setCookie = () => {
    const expires = new Date(Date.now() + COOKIE_LIFETIME_SECONDS * 1000).toUTCString();
    const secure = window.location.protocol === 'https:' ? '; Secure' : '';
    document.cookie = COOKIE_NAME + '=1; Max-Age=' + COOKIE_LIFETIME_SECONDS
        + '; Expires=' + expires + '; Path=/; SameSite=Lax' + secure;
    };

    const renderCartSections = sections => {
    if (!sections) return;

    if (sections['cart-drawer']) {
        const drawerDocument = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
        const currentDrawer = document.getElementById('cartDrawerSection');
        const incomingDrawer = drawerDocument.getElementById('cartDrawerSection');

        if (currentDrawer && incomingDrawer) {
            const selectors = [
              '.js-content-heading',
              '.js-content-items',
              '.cart-upsell-wrapper',
              '.js-content-footer-cart-notes',
              '.js-content-footer-subtotal'
            ];

            selectors.forEach(selector => {
              const currentElement = currentDrawer.querySelector(selector);
              const incomingElement = incomingDrawer.querySelector(selector);

              if (currentElement && incomingElement) {
                currentElement.innerHTML = incomingElement.innerHTML;
              }
            });

            const currentCartItems = currentDrawer.querySelector('cart-items');
            const incomingCartItems = incomingDrawer.querySelector('cart-items');
            if (currentCartItems && incomingCartItems) {
              currentCartItems.classList.toggle(
                'is-empty',
                incomingCartItems.classList.contains('is-empty')
              );
            }

            const currentButtons = currentDrawer.querySelector('.js-content-footer-buttons');
            const incomingButtons = incomingDrawer.querySelector('.js-content-footer-buttons');
            if (currentButtons?.parentElement && incomingButtons?.parentElement) {
              currentButtons.parentElement.classList.toggle(
                'hidden',
                incomingButtons.parentElement.classList.contains('hidden')
              );
            }

            if (typeof window.toggleCartDrawerCheckoutConfirmation === 'function') {
              window.toggleCartDrawerCheckoutConfirmation();
            }
        }
    }

    if (sections['cart-icon-bubble']) {
        const iconDocument = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
        const currentIcon = document.getElementById('cart-icon-bubble');
        const incomingIcon = iconDocument.getElementById('cart-icon-bubble');

        if (currentIcon && incomingIcon) {
        currentIcon.innerHTML = incomingIcon.innerHTML;
        }
    }

    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'vila-discount-session' });
    }

    document.dispatchEvent(new CustomEvent('vsl:cart-drawer:refreshed'));
    };

    const waitForDocument = () => {
    if (document.readyState !== 'loading') return Promise.resolve();

    return new Promise(resolve => {
        document.addEventListener('DOMContentLoaded', resolve, { once: true });
    });
    };

    const getShopRoot = () => {
    const configuredRoot = window.Shopify?.routes?.root || SHOP_ROOT || '/';
    return configuredRoot.endsWith('/') ? configuredRoot : configuredRoot + '/';
    };

    const updateCartDiscount = async discount => {
    const response = await fetch(getShopRoot() + 'cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({
        discount,
        sections: 'cart-drawer,cart-icon-bubble',
        sections_url: window.location.pathname + window.location.search
        })
    });

    if (!response.ok) throw new Error('Cart discount update failed.');

    const cart = await response.json();
    await waitForDocument();
    renderCartSections(cart.sections);
    return cart;
    };

    const clearOfferDiscounts = async () => {
    const response = await fetch(getShopRoot() + 'cart.js', {
        credentials: 'same-origin',
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
        cache: 'no-store'
    });

    if (!response.ok) throw new Error('Cart discount lookup failed.');

    const cart = await response.json();
    const remainingCodes = (cart.cart_level_discount_applications || [])
        .filter(application => application.type === 'discount_code')
        .map(application => application.title || application.code || '')
        .filter(code => code && !OFFER_DISCOUNT_CODES.has(code.toLowerCase()));

    return updateCartDiscount([...new Set(remainingCodes)].join(','));
    };

    const cookieWasPresent = hasCookie();
    let activatedDuringCleanup = false;
    let cleanupPromise = Promise.resolve();

    const activate = () => {
    setCookie();
    if (!cookieWasPresent) activatedDuringCleanup = true;
    };

    window.vilaDiscountSession = {
    activate,
    isActive: hasCookie,
    lifetimeSeconds: COOKIE_LIFETIME_SECONDS
    };

    document.addEventListener('click', event => {
    if (!(event.target instanceof Element)) return;

    const offerLink = event.target.closest('.vila-buy-offer__link');
    if (offerLink?.querySelector('.vila-buy-offer__action')) activate();
    }, true);

    if (!cookieWasPresent) {
    // This runs before page-specific offer scripts can read stale promotion state.
    removeStoredDiscount();

    cleanupPromise = clearOfferDiscounts().catch(error => {
        console.error('Discount expiry cleanup error:', error);
    });

    cleanupPromise.finally(() => {
        if (!activatedDuringCleanup || !hasCookie()) return;

        let activeCode = '';
        try {
        activeCode = localStorage.getItem('vilaDiscountCode') || '';
        } catch (error) {
        return;
        }

        // If the offer was claimed while cleanup was in flight, restore that new claim.
        if (activeCode) {
        updateCartDiscount(activeCode).catch(error => {
            console.error('Discount activation refresh error:', error);
        });
        }
    });
    }
})